import type { BoardActivityItem } from './types';

/**
 * Caps the panel's row list (newest first) at `cap` rows, as before, but never keeps part of an operation: when the
 * cut falls inside an operation (some of its rows beyond the cap), every row of that operation is dropped, so a
 * grouped entry always shows the whole call (AF3).
 */
export function trimActivities(list: BoardActivityItem[], cap: number): BoardActivityItem[] {
    if (list.length <= cap) {
        return list;
    }

    const kept = list.slice(0, cap);
    const cutOperationIds = new Set(
        list
            .slice(cap)
            .map((item) => item.operationId)
            .filter((operationId): operationId is string => !!operationId)
    );

    if (cutOperationIds.size === 0) {
        return kept;
    }

    return kept.filter((item) => !item.operationId || !cutOperationIds.has(item.operationId));
}
